import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { hotComics } from '@/mocks/comics';

export default function HotComicsSection() {
  return (
    <section className="py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              热门韩漫
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              千万读者热追的韩国漫画精选
            </p>
          </div>
          <Link
            to="/category/romance"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} size="large" />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-1 px-6 py-2.5 rounded-full bg-background-100 border border-background-200/70 text-sm text-foreground-600 hover:text-foreground-900 hover:bg-background-200/70 transition-colors"
          >
            查看全部热门韩漫
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}